import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { LanguageProvider } from './hooks/useLanguage';
import { ThemeProvider } from './hooks/useTheme';

import LoadingScreen from './components/LoadingScreen';
import ScrollProgress from './components/ScrollProgress';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import Process from './components/Process';
import TechStack from './components/TechStack';
import Stats from './components/Stats';
import Industries from './components/Industries';
// Testimonials hidden until real client feedback is available
// import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

import './styles/globals.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <LanguageProvider>
      <ThemeProvider>
        <AnimatePresence mode="wait">
          {isLoading ? (
            <motion.div
              key="loader"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.4 }}
            >
              <LoadingScreen />
            </motion.div>
          ) : (
            <motion.div
              key="app"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
              className="bg-app text-app min-h-screen"
            >
              <ScrollProgress />
              <Header />
              <main id="main">
                <Hero />
                <TrustBar />
                <Services />
                <Process />
                <TechStack />
                <Stats />
                <Industries />
                {/* <Testimonials /> */}
                <Pricing />
                <FAQ />
                <CTA />
                <Contact />
              </main>
              <Footer />
            </motion.div>
          )}
        </AnimatePresence>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
